// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.90.1-beta.2da6e0f79',
  revision: '2da6e0f79',
  branch: 'develop',
  date: 'Thu, 24 Sep 2026 15:40:12 GMT'
};